module.exports = "module.exports = __webpack_public_path__ + &quot;media/images/facebook-76a32ec518a42a51ce7342565e8d03c5.svg&quot;;"